export default __webpack_public_path__ + "static/media/Biene-und-Blumen.74ede77d.png";